/**
 * 操作日志 — GET /api/admin/oplog
 */
import { useState } from 'react';
import { Input, Select, Space, Tag, Tooltip } from 'antd';
import { DataTable } from '../../components/DataTable';

interface OpLogRow {
  id: string;
  admin_id: number;
  admin_name: string;
  action: string;
  route: string;
  method: string;
  status_code: number;
  result: 'ok' | 'error';
  ip: string | null;
  body_excerpt: string | null;
  error_msg: string | null;
  create_time: string;
}

export function OpLogPage() {
  const [adminId, setAdminId] = useState<string>('');
  const [action, setAction] = useState<string>('');
  const [result, setResult] = useState<'ok' | 'error' | undefined>();
  const [keyword, setKeyword] = useState<string>('');

  const columns = [
    { title: '时间', dataIndex: 'create_time', width: 170 },
    {
      title: '操作员',
      key: 'admin',
      width: 160,
      render: (_: unknown, row: OpLogRow) => (
        <span>
          {row.admin_name} <span style={{ color: '#999' }}>#{row.admin_id}</span>
        </span>
      ),
    },
    { title: '动作', dataIndex: 'action', width: 140 },
    {
      title: '方法',
      dataIndex: 'method',
      width: 80,
      render: (v: string) => <Tag>{v}</Tag>,
    },
    { title: '路由', dataIndex: 'route', ellipsis: true },
    {
      title: '状态',
      dataIndex: 'status_code',
      width: 80,
    },
    {
      title: '结果',
      dataIndex: 'result',
      width: 90,
      render: (v: 'ok' | 'error', row: OpLogRow) =>
        v === 'ok' ? (
          <Tag color="green">成功</Tag>
        ) : (
          <Tooltip title={row.error_msg ?? ''}>
            <Tag color="red">失败</Tag>
          </Tooltip>
        ),
    },
    { title: 'IP', dataIndex: 'ip', width: 140, render: (v: string | null) => v ?? '—' },
    {
      title: '请求载荷',
      dataIndex: 'body_excerpt',
      ellipsis: true,
      render: (v: string | null) =>
        v ? (
          <Tooltip title={<pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{v}</pre>}>
            <code style={{ fontSize: 12 }}>{v.slice(0, 80)}</code>
          </Tooltip>
        ) : (
          '—'
        ),
    },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>操作日志</h2>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="操作员 ID"
          style={{ width: 140 }}
          value={adminId}
          onChange={(e) => setAdminId(e.target.value)}
          allowClear
        />
        <Input
          placeholder="动作关键字"
          style={{ width: 180 }}
          value={action}
          onChange={(e) => setAction(e.target.value)}
          allowClear
        />
        <Select
          placeholder="结果"
          style={{ width: 120 }}
          allowClear
          value={result}
          onChange={setResult}
          options={[
            { value: 'ok', label: '成功' },
            { value: 'error', label: '失败' },
          ]}
        />
        <Input
          placeholder="搜索（路由/操作员/动作）"
          style={{ width: 260 }}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          allowClear
        />
      </Space>
      <DataTable<OpLogRow>
        queryKey={['admin', 'oplog', adminId, action, result ?? '', keyword]}
        endpoint="/api/admin/oplog"
        extraParams={{
          admin_id:
            adminId.trim() && !Number.isNaN(Number(adminId)) ? Number(adminId) : undefined,
          action: action.trim() || undefined,
          result,
          keyword: keyword.trim() || undefined,
        }}
        columns={columns}
        rowKey="id"
        scroll={{ x: 1400 }}
      />
    </div>
  );
}
